<template>
    <div>
        <div class="header">
            <h1 class="Title">FTRC Authentication Management</h1>
            <div class="Options">
                <button v-on:click.stop="signout()">Logout</button>
            </div>
            <user-details :user="UserDetails" />
        </div>
        <div class="TabHeader">
            <div class="tab"><input type="radio" v-model="SelectedTab" value="Users" id="rdUsers" /><label for="rdUsers">Users</label></div>
            <div class="tab"><input type="radio" v-model="SelectedTab" value="Rejected" id="rdRejUsers" /><label for="rdRejUsers">Rejected Users</label></div>
            <div class="tab"><input type="radio" v-model="SelectedTab" value="Companies" id="rdCompanies" /><label for="rdCompanies">Companies</label></div>
            <div class="tab"><input type="radio" v-model="SelectedTab" value="Settings" id="rdSettings" /><label for="rdSettings">Settings</label></div>
            <div class="tab"><input type="radio" v-model="SelectedTab" value="BulkImport" id="rdBulk" /><label for="rdBulk">Bulk Registration</label></div>
            <div class="tab"><input type="radio" v-model="SelectedTab" value="Campaign" id="rdCampaign" /><label for="rdCampaign">Free trial/discount campaigns</label></div>
        </div>
        <span>
            <users v-if="SelectedTab === 'Users'" Type="Users" />
        </span>
        <span>
            <users v-if="SelectedTab === 'Rejected'" Type="Rejected" />
        </span>
        <span>
            <companies v-if="SelectedTab === 'Companies'" />
        </span>
        <span>
            <settings v-if="SelectedTab === 'Settings'" />
        </span>
        <span>
            <bulk-import v-if="SelectedTab === 'BulkImport'" />
        </span>
        <span>
            <Campaign v-if="SelectedTab === 'Campaign'" />
        </span>
    </div>
</template>

<script>
    import $ from 'jquery';
    import Users from './components/Users.vue';
    import UserDetails from './components/UserDetails.vue';
    import Settings from './components/Settings.vue';
    import Companies from './components/Companies.vue';
    import BulkImport from './components/BulkImport.vue';
    import Campaign from './components/Campaign.vue';

    function getUrlParameter(name) {
        name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }


    var userId = getUrlParameter("userId");
    if (userId !== null) {
        window.location.hash = "#" + userId;
    }

    export default {
        name: 'App',
        props: ["Type"],
        components: {
            UserDetails,
            Settings,
            Companies,
            Users,
            BulkImport,
            Campaign
        },
        data: function () {
            return {
                UserDetails: null,
                SelectedTab: 'Users'
            };
        },
        created: function () {
            var thisControl = this;
            $.ajax({
                type: 'GET',
                url: 'User',
                contentType: 'application/json',
                success: function (UserDetails) {
                    thisControl.UserDetails = UserDetails;
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location = "/User/signin";
                        return;
                    }
                    alert("An Error Occured getting your user details")
                }
            });
        },
        methods: {
            signout: function () {

                window.location = "/User/signout";
            }
        }
    }
</script>

<style>
    @import '/Styles/Main.css?v=1';
</style>
